import { Box, Button, MenuItem } from "@material-ui/core"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import type { Licence } from "../../../redux"
import { TextInputField } from "../../atoms"
import { FormValidationErrors } from "../../molecules"

import "./licence-manager-form.styles.scss"

export interface ILicenceManagerFormProps {
  licence: Licence
  licences: Licence[]
  onSave: (licence: Licence) => void
}

export function LicenceManagerForm(props: ILicenceManagerFormProps): ReactElement {
  const { licence, licences, onSave } = props
  const {
    control,
    reset,
    handleSubmit,
    formState: { errors, submitCount }
  } = useForm<Licence>({
    defaultValues: licence,
    mode: "onSubmit",
    reValidateMode: "onChange"
  })

  const { t } = useTranslation("contentManager")
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    reset(licence)
  }, [licence])

  return (
    <form className="licence-manager-form" onSubmit={handleSubmit(onSave)}>
      {!licence.id && (
        <TextInputField name="baseLicenceId" control={control} label={t("licences.formFields.basicLicence")} select>
          {licences.map((licence: Licence) => (
            <MenuItem key={licence.id} value={licence.id}>
              {licence.name}
            </MenuItem>
          ))}
        </TextInputField>
      )}
      <Box className="grouped-fields">
        <TextInputField
          name="name"
          control={control}
          required={t("licences.formFields.requiredName")}
          label={t("licences.formFields.name")}
          placeholder={t("licences.formFields.licenceName")}
        />
        <TextInputField
          control={control}
          name="ean"
          required={t("licences.formFields.requiredEAN")}
          label={t("licences.formFields.ean")}
          placeholder={t("licences.formFields.ean")}
        />
      </Box>
      <Button type="submit" variant="contained" color="primary">
        {t("save")}
      </Button>
      <FormValidationErrors errors={errors} submitCount={submitCount} />
    </form>
  )
}
